import { useAuthStore } from '../stores/auth-store.js';

const API_BASE = import.meta.env.PROD
  ? 'https://cardealeros-api.bowling-anthony.workers.dev/v1'
  : '/v1';

interface ApiResponse<T> {
  success: boolean;
  data?: T;
  error?: string;
  code?: string;
  pipeline?: { mismatch_detected: boolean; warnings: string[] };
  pagination?: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

async function request<T>(method: string, path: string, body?: unknown): Promise<ApiResponse<T>> {
  const token = useAuthStore.getState().token;
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  if (res.status === 401 && !path.startsWith('/auth/')) {
    useAuthStore.getState().logout();
  }

  return res.json();
}

export const api = {
  get: <T>(path: string) => request<T>('GET', path),
  post: <T>(path: string, body?: unknown) => request<T>('POST', path, body),
  patch: <T>(path: string, body?: unknown) => request<T>('PATCH', path, body),
  delete: <T>(path: string) => request<T>('DELETE', path),
};
